import React, { useEffect, useState } from "react";
import { Container, Row, Col, InputGroup, Form } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import WebService from "../../../Services/WebService";
import Loader from "../../../components/Loader/Loader";
import LevelCard from "../../../components/LevelCard/LevelCard";
import "./Practise.scss";
import HelperService from "../../../Services/HelperService";

const Practise: React.FC = () => {
  const [levels, setLevels] = useState<any[]>([]);
  const [course, setCourse] = useState<any>(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const navigate = useNavigate();
  const { course_uuid } = useParams();

  // ✅ FIXED: async added + await added
  const coursDetails = async () => {
    try {
      const response: any = await WebService.getAPI({
        action: `/course/${course_uuid}`,
      });

      setCourse(response?.result || null);
    } catch (error) {
      console.error("Error fetching course details:", error);
      setCourse(null);
    }
  };

  // Levels
  const getLevels = async (reset = true, nextOffset = 0, keyword = "") => {
    setLoading(true);
    setDataLoaded(false);
    try {
      const response: any = await WebService.getAPI({
        action: `/level/list?limit=8&offset=${nextOffset}&course_id=${course_uuid}&keyword=${keyword}`,
      });

      const newData = response?.list || [];
      setLevels(reset ? newData : [...levels, ...newData]);
      setOffset(response?.next_offset || 0);
      setHasMore(response?.next_offset !== -1);
    } catch (error) {
      console.error("Error fetching levels:", error);
      setLevels([]);
    } finally {
      setLoading(false);
      setDataLoaded(true);
    }
  };

  // Fetch when course_uuid changes
  useEffect(() => {
    if (course_uuid) {
      coursDetails(); // Load certificate details
      getLevels(true, 0); // Load levels
    }
  }, [course_uuid]);

  // Search handler
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearch(value);
    if (value.length > 1 || value.length === 0) {
      getLevels(true, 0, value);
    }
  };

  const handleViewAll = () => {
    if (hasMore) getLevels(false, offset, search);
  };

  const handleLevelClick = (uuid: string) => {
    navigate(`/training/lesson/${uuid}`);
  };

  return (
    <Container fluid className="training-page p-3 px-0">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bold m-0">
          Certificate Name:
          <span style={{ marginLeft: "10px" }}>
            {course?.title  || "Loading..."} 
          </span>
        </h5>

        <div className="me-2">
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search"
              value={search}
              onChange={handleSearch}
              aria-label="Search"
              style={{ borderRadius: "8px", paddingLeft: "15px" }}
            />
            <InputGroup.Text
              style={{
                background: "transparent",
                border: "none",
                marginLeft: "-40px",
                zIndex: 10,
              }}
            >
              <FaSearch color="#89868D" />
            </InputGroup.Text>
          </InputGroup>
        </div>
      </div>

      {/* Loader */}
      {loading && (
        <div className="text-center my-5">
          <Loader show={true} />
        </div>
      )}

      {/* Content */}
      {!loading && dataLoaded && (
        <>
          <Row>
            {levels.length > 0 ? (
              levels.map((level, i) => (
                <Col lg={3} md={4} sm={6} key={i} className="mb-4">
                  <div
                    onClick={() => handleLevelClick(level.uuid)}
                    style={{ cursor: "pointer" }}
                  >
                    <LevelCard
                      title={level.title}
                      progress={level.complete_percentage || 0}
                      description={level.description || ""}
                      lessons={level.lesson_count}
                      totalTime={HelperService.formatDuration(
                        level.lesson_duration
                      )}
                      color="#00bfa6"
                    />
                  </div>
                </Col>
              ))
            ) : (
              <div className="text-center py-5 text-muted w-100">
                No Levels Found
              </div>
            )}
          </Row>

          {hasMore && levels.length > 0 && (
            <Row className="text-center mt-4">
              <div className="text-center">
                <button
                  className="btn btn-brand-1 d-block mx-auto"
                  onClick={handleViewAll}
                >
                  View all
                </button>
              </div>
            </Row>
          )}
        </>
      )}
    </Container>
  );
};

export default Practise;
